var CURRENT_MODULE;
(function (CURRENT_MODULE) {
    CURRENT_MODULE["WELCOME"] = "welcome";
    CURRENT_MODULE["WELCOME_LOGIN"] = "welcome-login";
    CURRENT_MODULE["WELCOME_SIGNUP"] = "welcome-signup";
    CURRENT_MODULE["INFO"] = "info";
    CURRENT_MODULE["LOGIN_BUNKER_URL"] = "login-bunker-url";
    CURRENT_MODULE["LOGIN_READ_ONLY"] = "login-read-only";
    CURRENT_MODULE["CONFIRM_LOGOUT"] = "confirm-logout";
    CURRENT_MODULE["IMPORT_FLOW"] = "import";
    CURRENT_MODULE["IMPORT_OTP"] = "import-otp";
    CURRENT_MODULE["LOGIN"] = "login";
    CURRENT_MODULE["SIGNUP"] = "signup";
    CURRENT_MODULE["LOCAL_SIGNUP"] = "local-signup";
    CURRENT_MODULE["EXTENSION"] = "extension";
    CURRENT_MODULE["LOADING"] = "loading";
    CURRENT_MODULE["PREVIOUSLY_LOGGED"] = "switch-account";
    CURRENT_MODULE["LOGIN_OTP"] = "otp";
    CURRENT_MODULE["CONNECT"] = "connect";
    CURRENT_MODULE["CONNECTION_STRING"] = "connection-string";
    CURRENT_MODULE["IFRAME"] = "iframe";
})(CURRENT_MODULE || (CURRENT_MODULE = {}));
var METHOD_MODULE;
(function (METHOD_MODULE) {
    METHOD_MODULE["LOGIN"] = "login";
    METHOD_MODULE["SIGNUP"] = "signup";
    METHOD_MODULE["LOGOUT"] = "logout";
    METHOD_MODULE["CONFIRM"] = "confirm";
})(METHOD_MODULE || (METHOD_MODULE = {}));

export { CURRENT_MODULE as C, METHOD_MODULE as M };

//# sourceMappingURL=index2.js.map